module.exports = __webpack_public_path__ + "static/media/card_m1.87d24f00.jpg";